import { get } from '@/services/http';
import {
    TierConfig,
    TierDistributionResponse,
    TierChangesResponse,
    PackageDistributionResponse,
    YesterdayUninstalls,
} from '@/types/churn';

export class ChurnDashboardModel {
    public distribution: TierDistributionResponse = { date: null, total: 0, tiers: [] };
    public tierChanges: TierChangesResponse = {
        date: null,
        summary: { escalated: 0, deEscalated: 0, total: 0 },
        changes: [],
    };
    public tierConfig: Record<string, TierConfig> = {};
    public packageDistribution: PackageDistributionResponse = { date: null, packages: [] };
    public yesterdayUninstalls: YesterdayUninstalls = {
        date: '',
        predicted: 0,
        notPredicted: 0,
        total: 0,
        correctionRate: 0,
        tierBreakdown: { critical: 0, high: 0, medium: 0, low: 0 },
    };

    public async fetch(): Promise<void> {
        const [distRes, changesRes, configRes, pkgDistRes, uninstallsRes]: any[] = await Promise.all([
            get('/churn/tier-distribution'),
            get('/churn/tier-changes'),
            get('/churn/tier-config'),
            get('/churn/distribution-by-package'),
            get('/churn/yesterday-uninstalls'),
        ]);

        this.mapData(distRes.data, changesRes.data, configRes.data, pkgDistRes.data);
        this.yesterdayUninstalls = uninstallsRes.data;
    }

    public mapData(
        distribution: TierDistributionResponse,
        tierChanges: TierChangesResponse,
        tierConfig: Record<string, TierConfig>,
        packageDistribution?: PackageDistributionResponse,
    ): void {
        this.distribution = distribution;
        this.tierChanges = tierChanges;
        this.tierConfig = tierConfig;
        if (packageDistribution) {
            this.packageDistribution = packageDistribution;
        }
    }

    public getTierCount(tier: string): number {
        const found = this.distribution.tiers.find((t) => t.tier === tier);
        return found ? found.count : 0;
    }
}
